import React, {useEffect, useState} from "react";

// reactstrap components
import {
    Alert,
    Button,
    Card,
    CardHeader,
    CardBody,
    TabContent,
    Form, FormGroup,
    Row,
    Col,
    Label,
    Input
  } from "reactstrap";

import {store} from './utils/httpUtil';
import {logError, checkError} from './utils/helpers';
import {Blocks} from './constants/Blocks';
import {ticketTypes} from './constants/TicketTypes';

function CheckOutDetails({gId}) {


    const [showAlert, setShowAlert] = useState(false);
    const [alertColor, setAlertColor] = useState();
    const [alertMsg, setAlertMsg] = useState();
    const [guestId, setGuestId] = useState();

    const [details, setDetails] = useState({
      GuestName: "", 
      TicketTypeIds: [], 
      BlockId: "",
      RoomNo: "",
      RoomKeyReturned: false,
      RoomKeyLost: false  
    });

    useEffect(() => { 
      setGuestId(gId);
      getGuestDetails(gId);
    }, [gId]);

    const getGuestDetails = async (guestId) => {
      return fetch("/apiCheckOut/" + guestId)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
            var data = result[0];
            
            setDetails({  
              GuestName : data.guest_name,    
              TicketTypeIds: data.ticket_type_ids.split(", "),             
              BlockId: data.block_id,
              RoomNo: data.room_no,
              RoomKeyReturned: data.room_key_returned,
              RoomKeyLost: data.room_key_lost
            });
      })
    }


    const populateBlocks = () => {
      let items = [];
      items = Object.keys(Blocks).map((key) => (
        <option key={key} value={key}>{Blocks[key]}</option>
      ));

      return items;
    }

    const updateCheckOut = async (e) => {

      e.preventDefault();
      
        const payload = {
          block_id: details.BlockId,
          room_no: details.RoomNo.trim(),
          room_key_returned: details.RoomKeyReturned,
          room_key_lost: details.RoomKeyLost
        };
      
      const response = await store("/apiCheckOut/" + guestId, JSON.stringify(payload))
      .then((response) => {
        if (response.status === 200) {
          setAlertMsg(details.GuestName + " saved successfully.");
          setAlertColor("success");
          setShowAlert(true);

          setTimeout(() => {
            document.getElementById("frmCheckOut").submit();
          }, 2000); // Delay of 3 seconds

        } else {
          setAlertMsg("Oops, there has been issue. Please try again.")
          setAlertColor("danger");
          setShowAlert(true);
        }
      })
      .catch((error) => {
        setAlertMsg(error.response.data.message)
        setAlertColor("danger");
        setShowAlert(true);
      });
    }
      
  return (
          <div className="wrapper">
              <div id="divCheckOutDetails" className="divDetails">
                    <Col className="text-left" md="10">
                        <h5 className="description">
                              <Card>
                                    <CardHeader>{details.GuestName}</CardHeader>
                                    <CardBody>
                                    {details.TicketTypeIds.map((guestTicketType, index) => (
                                            <div className="divTicketTypes" key={index}>{ticketTypes[guestTicketType]}</div>
                                        ))}
                                            <TabContent className="text-left">                                       
                                            <Form id="frmCheckOut" onSubmit={(e) => updateCheckOut(e)}>
                                            <Alert isOpen={showAlert} color={alertColor}>
                                              {alertMsg}
                                            </Alert>
                                                  <Row>
                                                        <Col md={3}>
                                                              <FormGroup>
                                                                <Label for="slBlocks" className="form-label">
                                                                  Block:
                                                                </Label>
                                                                <Input type="select" required id="slBlocks" className="form-control" value={details.BlockId} onChange={(e) => setDetails({ ...details, BlockId: e.target.value })} >
                                                                <option key={0} value={""}>Please select one</option>
                                                                  {populateBlocks()}
                                                                </Input>
                                                              </FormGroup>
                                                        </Col>
                                                        <Col md={3}>
                                                              <FormGroup>
                                                                <Label for="txtRoomNo" className="form-label">
                                                                  Room No:
                                                                </Label>
                                                                <Input required type="text" id="txtRoomNo" value={details.RoomNo} onChange={(e) => setDetails({ ...details, RoomNo: e.target.value })} />
                                                              </FormGroup>
                                                        </Col>
                                                        <Col md={3}>
                                                             <FormGroup check style={{marginTop:'2em'}}>
                                                                <Input type="checkbox" id="chkRoomKeyGiven" checked={details.RoomKeyReturned} onChange={(e) => setDetails({ ...details, RoomKeyReturned: e.target.checked })} /> 
                                                                    {' '}
                                                                <Label check>
                                                                  Key returned?
                                                                </Label>
                                                              </FormGroup>
                                                        </Col>
                                                        <Col md={3}>
                                                              <FormGroup check style={{marginTop:'2em'}}>
                                                                <Input type="checkbox" id="chkRoomKeyLost" checked={details.RoomKeyLost} onChange={(e) => setDetails({ ...details, RoomKeyLost: e.target.checked })} /> 
                                                                    {' '}
                                                                <Label check>
                                                                  Key Lost?
                                                                </Label>
                                                              </FormGroup>
                                                        </Col> 
                                                    </Row>
                                                    <Row>
                                                        <Col md={10}>
                                                                <Button color="primary" type="submit">
                                                                Save
                                                                </Button>
                                                            <br/> 
                                                        </Col>
                                                    </Row>
                                                  </Form>
                                            </TabContent>
                                    </CardBody>
                              </Card>
                        </h5>
                  </Col>
              </div>
        </div>
  );                                                                                            
}

export default CheckOutDetails;
